var _path, _g, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAccordionDownArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 37,
    viewBox: "0 0 36 37",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_424_5900",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 36,
    height: 37
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 0.732422H35.928V36.6609H0V0.732422Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_424_5900)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.9641 2.09955C8.85219 2.09955 1.4375 9.51555 1.4375 18.6262C1.4375 27.7368 8.85285 35.1528 17.9641 35.1528C27.0747 35.1528 34.4907 27.7368 34.4907 18.6262C34.4907 9.51555 27.0747 2.09955 17.9641 2.09955ZM17.964 36.5897C13.1642 36.5897 8.65113 34.7217 5.25927 31.3298C1.86742 27.9386 0 23.4262 0 18.6257C0 13.8253 1.86807 9.31285 5.25927 5.921C8.65047 2.52914 13.1636 0.661072 17.964 0.661072C22.7644 0.661072 27.2769 2.5298 30.6681 5.921C34.0606 9.31285 35.928 13.8253 35.928 18.6257C35.928 23.4262 34.0599 27.9379 30.6681 31.3298C27.2769 34.7217 22.7644 36.5897 17.964 36.5897Z",
    className: "color17Fill"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.9365 9.66107L10 22.36L25.873 22.36L17.9365 9.66107Z",
    className: "color17Fill"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAccordionDownArrow);
export default __webpack_public_path__ + "static/media/accordion-down-arrow.e4fe3a06ea205e8f43bc736366342140.svg";
export { ForwardRef as ReactComponent };